export default "__VITE_ASSET__Br2jNT4n__"